import axiosInstance from "./axiosInstance";

export const verificarNoches = async (id, noches, llegada, salida) => {
  return await axiosInstance.get(
    `${process.env.REACT_APP_BASE_URL}/verificarNoches?id=${id}&noches=${noches}&llegada=${llegada}&salida=${salida}`
  );
};
